__webpack_require__.p = "https://matchcenter-api.24media.gr/widget/241a2c5232bae7c519d0/";